import ReportBoxArea from "./report_box";
import CounselBox from "./counsel_box";

function CardBoxArea(props: any) {
  let myProps = {
    select_date: "",
    stu_info: {},
    stu_info_arr: [],
    set_stu_info_arr: (inData: any) => { },
    Style: {},
    check_seq_arr: [],
    set_check_seq_arr: (inData: any) => { },
    copy_clipboard_report: (inData: any) => { },
    get_comment_by_open_ai_ajax: (inData: any) => { },
    counsel_todo_arr: [],
    write_stu_par_report_by_ajax: (inData: any) => { },
    delete_stu_par_report_by_ajax: (inData: any) => { },
    stu_par_report_arr: [],
    is_exist_katalk_send: false,
    check_counsel_seq_arr: [],
    set_check_counsel_seq_arr: (inData: any) => { },
    wrtie_counsel_todo_by_ajax: (inData: any) => { },
    open_view_counsel_todo: (inData: any) => { },
    ...props
  };
  let stu_info = myProps.stu_info;
  let Style = myProps.Style;

  return (
    <div className={Style.card_box}>
      <div className={Style.card_box_con}>
        <ReportBoxArea
          stu_info={stu_info}
          stu_info_arr={myProps.stu_info_arr}
          set_stu_info_arr={myProps.set_stu_info_arr}
          Style={Style}
          check_seq_arr={myProps.check_seq_arr}
          set_check_seq_arr={myProps.set_check_seq_arr}
          copy_clipboard_report={myProps.copy_clipboard_report}
          get_comment_by_open_ai_ajax={myProps.get_comment_by_open_ai_ajax}
          wrtie_counsel_todo_by_ajax={myProps.wrtie_counsel_todo_by_ajax}
          open_view_counsel_todo={myProps.open_view_counsel_todo}
        ></ReportBoxArea>
        <CounselBox
          select_date={myProps.select_date}
          stu_info={stu_info}
          Style={Style}
          check_counsel_seq_arr={myProps.check_counsel_seq_arr}
          set_check_counsel_seq_arr={myProps.set_check_counsel_seq_arr}
          stu_par_report_arr={myProps.stu_par_report_arr}
          is_exist_katalk_send={myProps.is_exist_katalk_send}
          write_stu_par_report_by_ajax={myProps.write_stu_par_report_by_ajax}
          delete_stu_par_report_by_ajax={myProps.delete_stu_par_report_by_ajax}
        ></CounselBox>
      </div>
    </div>
  );
};
export default CardBoxArea;